/*
 * @Author: chenxiao
 * @Date: 2022-02-18 15:50:36
 * @LastEditors: chenxiao
 * @LastEditTime: 2022-02-18 17:41:05
 */
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
import fastChoose from '@/view/fastChoose/index'
import chooseLoc from '@/view/fastChoose/chooseLoc'
import planRoad from '@/view/fastChoose/planRoad'
import roadDetialList from '@/view/roadDetialList/index'

Vue.use(Router)

// export default new Router({
//   routes: [
//     { path: "/", component: resolve => require(['@/view/index'], resolve), meta: { title: "辽宁简图"} },//重定向（设定默认路由）
//     { path: "/fastChoose", component: resolve => require(['@/view/fastChoose/index'], resolve), meta: { title: "路线规划" } },
//     { path: "/chooseLoc", component: resolve => require(['@/view/fastChoose/chooseLoc'], resolve), meta: { title: "选择位置" } },    
//     { path: "/planRoad", component: resolve => require(['@/view/fastChoose/planRoad'], resolve), meta: { title: "路线详情" } },
//     { path: "/roadDetialList", component: resolve => require(['@/view/roadDetialList/index'], resolve), meta: { title: "路线详情" } },
//   ]
// })
export default new Router({
  // mode:'history',
  routes: [
    { path: "/", component: Index, meta: { title: "辽宁简图"} },//重定向（设定默认路由）
    { path: "/fastChoose", component: fastChoose, meta: { title: "路线规划"} },//重定向（设定默认路由）
    { path: "/chooseLoc", component: chooseLoc, meta: { title: "选择位置"} },//重定向（设定默认路由）
    { path: "/planRoad", component: planRoad, meta: { title: "路线详情"} },//重定向（设定默认路由）
    { path: "/roadDetialList", component: roadDetialList, meta: { title: "路线详情"} },//重定向（设定默认路由）
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js